export const referencesEnvironment = {
  // Hosting region shown to candidates in the document-upload privacy notice.
  REGION: 'ca',
  GOOGLE_ANALYTICS: {
    domain: 'auto',
    GTM: 'GTM-KNFJWXT'
  },
  GOOGLE_SEARCH: {
    key: 'AIzaSyDRqBZS-N-WBmYqb5fK_Gdhxw3p-RUytiQ'
  }
};
